export const WORKFLOWS_CATEGORIES = [
    'All Categories',
    'Content / SEO',
    'PR / Communication',
    'Email Marketing',
    'Social',
    'Custom',
    'Sales',
];
